import { sendRequest } from 'config/api';
export const COMPANY_URL = '/org/company';
export const COURSES_URL = '/lms/course/catalogue/';
export const PLANS_URL = '/subscription/plan/';

export const setCompanyCourses = (companyId: string, courseIds: string[]) =>
  sendRequest(`${COMPANY_URL}/${companyId}/`, { courses: courseIds }, 'PATCH');

export const fetchCoursesInProgress = (companyId: string) =>
  sendRequest(`${COMPANY_URL}/${companyId}/courses-in-progress/`);

export const fetchAssignedCourses = (companyId: string) =>
  sendRequest(`${COMPANY_URL}/${companyId}/assigned-courses/`);

export const fetchCoursesPage = (page = 1, includeInactive = false) =>
  sendRequest(
    `${COURSES_URL}?page=${page}${includeInactive ? '&include_inactive=true' : ''}`
  );

export const fetchAllCourses = async (includeInactive = false, maxPages = 25) => {
  const collected: any[] = [];
  let page = 1;
  let totalPages = 1;

  while (page <= totalPages && page <= maxPages) {
    const { data } = await fetchCoursesPage(page, includeInactive);
    collected.push(...(data?.results ?? []));
    totalPages = data?.total_pages ?? 1;
    if (!data?.links?.next) break;
    page += 1;
  }

  return collected;
};

export const fetchPlans = () => sendRequest(PLANS_URL);

export const registerCompany = (payload: {
  email: string;
  password: string;
  firstname: string;
  lastname: string;
  phone?: string;
  company: { name: string; domain: string; about?: string };
}) => sendRequest('/auth/users/register/', payload, 'POST');

export const CATEGORIES_URL = '/lms/category/';
export const fetchCategories = () => sendRequest(CATEGORIES_URL);
export const updateCourse = (courseId: string, payload: any) =>
  sendRequest(`/lms/course/${courseId}/`, payload, 'PATCH');
